import React from 'react';
import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';
import { LEDIndicator, type LEDState } from './LEDIndicator';

interface ReviewSectionButtonProps {
  icon: React.ElementType;
  title: string;
  details: (string | React.ReactNode)[];
  onClick: () => void;
  ledState?: LEDState;
  className?: string;
  'data-testid'?: string;
}

export const ReviewSectionButton: React.FC<ReviewSectionButtonProps> = ({
  icon: Icon,
  title,
  details,
  onClick,
  ledState = 'complete',
  className,
  ...props
}) => {
  return (
    <button
      type="button"
      className={cn(
        'equipment-panel w-full text-left p-4 relative',
        'flex items-start gap-3',
        'hover:bg-[var(--color-surface-2)] transition-colors duration-150 cursor-pointer',
        className,
      )}
      onClick={onClick}
      {...props}
    >
      <div className="flex items-center gap-3 shrink-0 mt-0.5">
        <LEDIndicator state={ledState} />
        <Icon className="h-4 w-4 text-muted-foreground" />
      </div>

      <div className="flex-1 min-w-0">
        <h4 className="font-heading text-sm font-semibold uppercase tracking-[0.05em] text-foreground">
          {title}
        </h4>
        <div className="mt-1 space-y-0.5">
          {details.map((detail, index) =>
            typeof detail === 'string' ? (
              <p key={index} className="text-xs text-muted-foreground truncate">
                {detail}
              </p>
            ) : (
              <React.Fragment key={index}>{detail}</React.Fragment>
            )
          )}
        </div>
      </div>

      <ChevronRight className="shrink-0 h-4 w-4 text-muted-foreground self-center" />
    </button>
  );
};
